import { Loading } from 'components/loading'
import { TinymceEditorComponent } from 'components/tinymce-editor/tinymceditor'
import { MultiSelectDropdown } from 'components/dropdown/component'
import { Dataset } from 'generic/dataset'
import { RasaContext } from 'context'
import * as React from 'react'
import { connect } from 'react-redux'
import * as Router from 'router'
import * as Modals from 'shared/modals'
import { Editor as TinyMCEEditor } from "tinymce";
import * as Constants from './constants'
import { DatePicker } from '@progress/kendo-react-dateinputs'
import { DropdownComponent, DropdownOption, OnChangeEvent } from 'components/dropdown/component'
import * as Flash from 'components/flash'

interface State {
  selectedStatus: DropdownOption,
  activeTab: string,
  selectedAccounts: any[],
  sendEmail: boolean,
  notifyOwnerOnly: boolean,
  accountOptions: any[],
  isLoadingAccounts: boolean,
}
type AddNotificationState = Constants.Notification & Modals.ModalComponentState & State

interface AddNotificationProps extends Modals.ModalComponentProps {
  push: any,
  createOrUpdate: (payload: any) => Promise<any>
}

export class AddNotificationModalComponent extends Modals.GenericModalComponent<AddNotificationProps,
AddNotificationState> {
  public static contextType = RasaContext
  public static key: string = 'addNotification'
  public static defaultProps = {
    closeButtonText: 'Close',
    saveText: 'Save',
    secondAction: Modals.ModalActionType.BUTTON,
    title: 'Add Notification',
  }
  private _tinymceInstance: TinyMCEEditor
  private isSaveButtonDisabled: boolean = false
  constructor(props: AddNotificationProps) {
    super(props, AddNotificationModalComponent.key, 'Add Notification')
    const modalData = this.props.data[this.key].data
    this.state = {
      title: modalData.title,
      description: modalData.description,
      start_date: modalData.start_date,
      end_date: modalData.end_date,
      status: modalData.status || Constants.StatusFilters[0].value,
      link_url: modalData.link_url,
      isSaving: false,
      selectedStatus: Constants.StatusFilters[0],
      activeTab: Constants.NotificationType.GLOBAL,
      selectedAccounts: modalData.selected_accounts || [],
      sendEmail: modalData.send_email !== undefined ? modalData.send_email : true,
      notifyOwnerOnly: modalData.notify_owner_only !== undefined ? modalData.notify_owner_only : true,
      accountOptions: [],
      isLoadingAccounts: false,
    }
  }

  public componentDidMount() {
    this.loadAccountOptions()
  }

  public componentWillReceiveProps(nextProps) {
    const modalData = nextProps.data[this.key].data
    if (modalData.id && modalData.id !== this.state.id) {
      this.setState({id: modalData.id})
    }
    if (modalData.title && modalData.title !== this.state.title) {
      this.setState({title: modalData.title})
    }
    if (modalData.description && modalData.description !== this.state.description) {
      this.setState({description: modalData.description})
    }
    if (modalData.start_date && modalData.start_date !== this.state.start_date) {
      this.setState({start_date: new Date(modalData.start_date)})
    }
    if (modalData.end_date && modalData.end_date !== this.state.end_date) {
      this.setState({end_date: new Date(modalData.end_date)})
    }
    if (modalData.status && modalData.status !== this.state.status) {
      this.setState({status: modalData.status})
    }
    if (modalData.link_url && modalData.link_url !== this.state.link_url) {
      this.setState({link_url: modalData.link_url})
    }
  }

  protected renderChildren(data: any) {
    return (
      <div className="add-notification-modal-body">
        {this.state.isSaving
        ? <Loading size="64"/>
        : <div className='add-notification-form'>
            {/* Professional Tab Navigation */}
            <div className="notification-tabs">
              <div className="tab-nav">
                {Constants.NotificationTypeTabs.map(tab => (
                  <div
                    key={tab.key}
                    className={`tab-item ${this.state.activeTab === tab.key ? 'active' : ''}`}
                    onClick={() => this.setState({ activeTab: tab.key })}
                  >
                    <div className="tab-icon">
                      {tab.key === Constants.NotificationType.GLOBAL ? '🌐' : '🏢'}
                    </div>
                    <div className="tab-content">
                      <div className="tab-title">{tab.label}</div>
                      <div className="tab-subtitle">
                        {tab.key === Constants.NotificationType.GLOBAL 
                          ? 'Notify all users' 
                          : 'Target specific accounts'}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="tab-content-area">
              {/* Account Level Tab Content - Show at top when active */}
              {this.state.activeTab === Constants.NotificationType.ACCOUNT && (
                <div className="account-level-section">
                  <div className='form-group'>
                    <label className="form-label">Select Accounts *</label>
                    <div className="multiselect-wrapper">
                      {this.state.isLoadingAccounts ? (
                        <div className="loading-accounts">Loading accounts...</div>
                      ) : (
                        <MultiSelectDropdown
                          placeholder="Search and select accounts..."
                          options={this.state.accountOptions}
                          selected={this.state.selectedAccounts}
                          onSelect={this.handleAccountMultiSelect}
                          className="account-multiselect"
                        />
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* Common Notification Details */}
              <div className="notification-details-section">

                <div className='form-group'>
                  <label className="form-label">Title *</label>
                  <input
                    type="text"
                    className="form-input"
                    value={this.state.title}
                    placeholder="Enter notification title..."
                    onChange={(e) => {
                      e.preventDefault()
                      this.setState({ title: e.target.value })
                    }}
                  />
                </div>

                <div className='form-group'>
                  <label className="form-label">Description *</label>
                  <div className="editor-wrapper">
                    <TinymceEditorComponent
                      html={this.state.description ? this.state.description : ''}
                      height='300'
                      instance={(editor: TinyMCEEditor) =>  this.tinymceInstance(editor)}
                      onChange={(html: string) => this.articleDescription(html) }
                      showCharacterCount={true} />
                  </div>
                </div>

                {/* Show date/status fields only for Global notifications */}
                {this.state.activeTab === Constants.NotificationType.GLOBAL ? (
                  <div className='form-row'>
                    <div className='form-group'>
                      <label className="form-label">Start Date *</label>
                      <DatePicker 
                        className="date-picker"
                        format="yyyy-MM-dd"
                        value={this.state.start_date}
                        onChange={(e) => this.setState({start_date: e.value})} 
                      />
                    </div>
                    <div className='form-group'>
                      <label className="form-label">End Date</label>
                      <DatePicker 
                        className="date-picker"
                        format="yyyy-MM-dd"
                        value={this.state.end_date}
                        onChange={(e) => this.setState({end_date: e.value})} 
                      />
                    </div>
                    <div className='form-group'>
                      <label className="form-label">Status</label>
                      <DropdownComponent 
                        data={Constants.StatusFilters} 
                        selected={this.state.selectedStatus.key}
                        onChange={this.statusChanged}
                        className="status-dropdown"
                      />
                    </div>
                  </div>
                ) : (
                  // For account level, set default values and don't show these fields
                  null
                )}

                {/* Account Level Options at bottom */}
                {this.state.activeTab === Constants.NotificationType.ACCOUNT && (
                  <div className="notification-options-inline">
                    <div className="form-group checkbox-group">
                      <label className="checkbox-label">
                        <input
                          type="checkbox"
                          checked={this.state.sendEmail}
                          onChange={(e) => this.setState({ sendEmail: e.target.checked })}
                        />
                        <span className="checkmark"></span>
                        <div className="checkbox-text">
                          <div className="checkbox-title">Send Email Notification</div>
                          <div className="checkbox-desc">Also send notification via email</div>
                        </div>
                      </label>
                    </div>

                    <div className="form-group checkbox-group">
                      <label className="checkbox-label">
                        <input
                          type="checkbox"
                          checked={this.state.notifyOwnerOnly}
                          onChange={(e) => this.setState({ notifyOwnerOnly: e.target.checked })}
                        />
                        <span className="checkmark"></span>
                        <div className="checkbox-text">
                          <div className="checkbox-title">Notify Owner Only</div>
                          <div className="checkbox-desc">Send only to account owners, not all users</div>
                        </div>
                      </label>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        }
        <div>
        { this.isSaveButtonDisabled
        ? <div className="invalid-source-name-container">You already have a section with this name</div>
        : null}
        </div>
      </div>
    )
  }

  protected statusChanged = (e: OnChangeEvent) => {
    this.setState({
      selectedStatus: e.selected,
      status: e.selected.value,
    })
  }

  protected loadAccountOptions = () => {
    this.setState({ isLoadingAccounts: true })
    
    // Using the same dataset as SearchAccount component
    new Dataset().loadCommunityDataset('billingPlanAccounts', '', [])
      .then((result) => {
        const accounts = result[0] || []
        const accountOptions = accounts.map((account: any) => ({
          value: account.id,
          label: `${account.company_name} (${account.owner_email})`,
          ...account
        }))
        
        this.setState({ 
          accountOptions,
          isLoadingAccounts: false 
        })
      })
      .catch(() => {
        this.setState({ isLoadingAccounts: false })
      })
  }

  protected handleAccountMultiSelect = (selectedOptions: any[]) => {
    this.setState({ selectedAccounts: selectedOptions || [] })
  }

  protected tinymceInstance = (instance: TinyMCEEditor) => {
    this._tinymceInstance = instance
  }

  protected articleDescription = (description: string) => {
    if(this._tinymceInstance.isDirty()) {
      this.setState({
        description
      })
    }
  }

  protected close = (data: any) => {
    return this.props.closeModal(AddNotificationModal.key)
  }

  protected saveDisabled(data: any): boolean {
    const isAccountLevel = this.state.activeTab === Constants.NotificationType.ACCOUNT
    
    if (isAccountLevel) {
      // For account level: only require title, description, and at least one account
      return this.state.title === '' || 
             this.state.description === '' || 
             this.state.selectedAccounts.length === 0
    } else {
      // For global: require title, description, and start_date
      return this.state.title === '' || 
             this.state.description === '' || 
             this.state.start_date === null
    }
  }

  protected getSaveText(data: any): string {
    if (this.state.isSaving) {
      return this.state.activeTab === Constants.NotificationType.ACCOUNT ? 'Sending...' : 'Saving...'
    }
    return this.state.activeTab === Constants.NotificationType.ACCOUNT ? 'Send' : 'Save'
  }

  protected doSave(data: any) {
    const isAccountLevel = this.state.activeTab === Constants.NotificationType.ACCOUNT
    
    return this.props.createOrUpdate({
      id: this.state.id,
      title: this.state.title,
      description: this.state.description,
      start_date: isAccountLevel ? new Date() : this.state.start_date, // Use current date for account level
      end_date: isAccountLevel ? null : this.state.end_date, // No end date for account level
      status: isAccountLevel ? 'Published' : this.state.status, // Default to Published for account level
      link_url: this.state.link_url,
      notification_type: this.state.activeTab,
      selected_accounts: isAccountLevel ? this.state.selectedAccounts : [],
      send_email: isAccountLevel ? this.state.sendEmail : false,
      notify_owner_only: isAccountLevel ? this.state.notifyOwnerOnly : false,
    }).then(() => {
      // Show success flash message
      const successMessage = isAccountLevel ? 'Notification sent successfully!' : 'Notification saved successfully!'
      this.context.store.dispatch(Flash.showFlashMessage(successMessage))
      
      this.setState({
        isSaving: false,
        id: '',
        title: '',
        description: '',
        start_date: null,
        end_date: null,
        status: '',
        link_url: '',
        activeTab: Constants.NotificationType.GLOBAL,
        selectedAccounts: [],
        sendEmail: true, // Reset to default true
        notifyOwnerOnly: true, // Reset to default true
      })
    });
  }
}

export const AddNotificationModal = connect(
  null,
  {
    push: Router.push,
  },
)(AddNotificationModalComponent)
